<template>
  <div>
    <app-title-bar>
      <app-material-icon name="id_card" />
      <h2>{{ $t('profile.views.IdentityChecking.title') }}</h2>
    </app-title-bar>
    <div class="d-flex flex-column row-gap-6 justify-center align-center layout-spacing">
      <template v-if="idCheckStatePending">
        <v-progress-circular size="24" indeterminate color="primary"/>
      </template>
      <template v-else>
        <template v-if="canCurrentUserSign">
          <p>
            <font-awesome-icon class="text-success" :icon="['fas', 'check-circle']"></font-awesome-icon>
            {{ $t('profile.views.IdentityChecking.verified', { untilDate: validUntilDate }) }}
          </p>
        </template>
        <template v-else>
          <p>{{ $t('profile.views.IdentityChecking.notVerified') }}</p>
          <app-button
            class="mx-auto"
            @click="SET_SHOW_IDENTITY_CHECK_MODAL(true)"
          >
            {{ $t('profile.views.IdentityChecking.verifyBtn') }}
          </app-button>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import { ISOToDDMMYYYY } from '../../common/utils/dates'
import { GET_ID_CHECK_STATE } from '../../store/modules/user/action_types'
import { SET_SHOW_IDENTITY_CHECK_MODAL } from '../../store/modules/user/mutation_types'
const { mapMutations, mapActions, mapState } = createNamespacedHelpers('user')

export default {
  name: 'IdentityChecking',
  computed: {
    ...mapState(['idCheckState', 'idCheckStatePending']),
    canCurrentUserSign () {
      return this.idCheckState && this.idCheckState.hasValidIdCheck
    },
    validUntilDate () {
      return this.canCurrentUserSign && ISOToDDMMYYYY(this.idCheckState.idCheckValidUntil)
    },
  },
  created () {
    this.GET_ID_CHECK_STATE()
  },
  methods: {
    ...mapActions([GET_ID_CHECK_STATE]),
    ...mapMutations([SET_SHOW_IDENTITY_CHECK_MODAL]),
  },
}
</script>
